(() => {
  const init = (section) => {
    if (section.dataset.mpSetupReady === 'true') return;
    section.dataset.mpSetupReady = 'true';

    const track = section.querySelector('[data-mp-setup-track]');
    const tabs = [...section.querySelectorAll('[data-mp-setup-tab]')];
    const cards = [...section.querySelectorAll('[data-mp-setup-card]')];
    const dots = [...section.querySelectorAll('[data-mp-setup-dot]')];
    let active = 0;
    let frame;

    const update = (index) => {
      active = Math.max(0, Math.min(index, tabs.length - 1));
      tabs.forEach((tab, i) => {
        const selected = i === active;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
      });
      cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === active);
        card.classList.toggle('is-muted', i !== active);
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };

    const select = (index) => {
      update(index);
      if (window.matchMedia('(max-width: 989px)').matches && cards[index]) {
        track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    };

    tabs.forEach((tab, index) => tab.addEventListener('click', () => select(index)));

    /* Chaque carte est cliquable et se comporte exactement comme son onglet :
       la carte devient active, l'onglet correspondant s'active, l'état se synchronise. */
    cards.forEach((card, index) => card.addEventListener('click', (event) => {
      if (event.target.closest('a, button')) return;
      select(index);
    }));

    track.addEventListener('scroll', () => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let nearest = 0;
        let distance = Infinity;
        cards.forEach((card, i) => {
          const next = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
          if (next < distance) { distance = next; nearest = i; }
        });
        update(nearest);
      });
    }, { passive: true });

    /* Drag SOURIS uniquement (<990px, quand la piste est un scroller).
       Le tactile garde le scroll natif + scroll-snap (aucun handler posé) :
       aucune interférence avec le scroll vertical. rAF pour la fluidité. */
    let mDrag = false, mMoved = false, mStartX = 0, mStartScroll = 0, mTarget = 0, mRaf = null;
    const mApply = () => { mRaf = null; track.scrollLeft = mTarget; };
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (window.matchMedia('(min-width: 990px)').matches) return;
      mDrag = true; mMoved = false;
      mStartX = event.clientX;
      mStartScroll = track.scrollLeft;
      mTarget = mStartScroll;
      track.setPointerCapture?.(event.pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (!mDrag) return;
      const d = event.clientX - mStartX;
      if (Math.abs(d) > 4) mMoved = true;
      mTarget = mStartScroll - d;
      if (mRaf === null) mRaf = requestAnimationFrame(mApply);
    });
    const mEnd = (event) => {
      if (!mDrag) return;
      mDrag = false;
      if (mRaf !== null) { cancelAnimationFrame(mRaf); mRaf = null; }
      track.scrollLeft = mTarget;
      track.releasePointerCapture?.(event.pointerId);
    };
    track.addEventListener('pointerup', mEnd);
    track.addEventListener('pointercancel', mEnd);
    track.addEventListener('click', (event) => {
      if (mMoved) { event.preventDefault(); event.stopPropagation(); mMoved = false; }
    }, true);

    let startIndex = 0;
    const ds = Number(section.dataset.mpSetupStart);
    if (ds && ds > 0 && ds < tabs.length && window.matchMedia('(min-width: 990px)').matches) {
      startIndex = ds;
    }
    update(startIndex);
  };

  const boot = (root = document) => root.querySelectorAll('[data-mp-setup]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot()) : boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
